import { styled } from '@mui/material/styles';

export const FeaturedArticles = styled('div')(({ theme }) => ({
  '& > div': {
    paddingTop: theme.spacing(8),

    '& > div': {
      maxWidth: 'unset',
      padding: 0,
    },
  },

  [theme.breakpoints.up('md')]: {
    img: {
      maxHeight: '194px',
    },
  },

  p: {
    height: 'unset',
  },
}));
